export class BaseFilterKeyValueRule {
    expectedFilterKeyValues;
    constructor(expectedFilterKeyValues) {
        this.expectedFilterKeyValues = expectedFilterKeyValues;
    }
    forSearch(dependencies) {
        const { seoInfoBase, filterState } = dependencies;
        for (const [key, values] of this.expectedFilterKeyValues) {
            const optionValue = seoInfoBase.getFilterOptionValueBy(key, filterState);
            if (!optionValue || !values.includes(optionValue)) {
                return Promise.resolve(false);
            }
        }
        return Promise.resolve(true);
    }
    forSitemapGenerator(filterKeyValues) {
        for (const [key, values] of this.expectedFilterKeyValues) {
            const filterValues = filterKeyValues.get(key);
            if (!filterValues || filterValues.length !== values.length) {
                return Promise.resolve(false);
            }
            if (!values.every((value) => filterValues.includes(value))) {
                return Promise.resolve(false);
            }
        }
        return Promise.resolve(true);
    }
}
